import "./CategoriesAndServices.scss";

import React, { useMemo, useState } from "react";

import Categories from "./components/Categories";
import FloatingVideoButton from "../../commons/buttons/FloatingVideoButton";
import Services from "./components/Services";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

function CategoriesAnServices() {
  const [activeKey, setActiveKey] = useState("category");

  const showServices = useMemo(() => activeKey === "services", [activeKey]);

  return (
    <div className="container-md cs-page">
      <div className="cs-tabsHeader">
        <div className="cs-title">
          <div className="cs-title__h">Serviços</div>
          <div className="cs-title__p">Organize categorias e serviços do seu salão.</div>
        </div>

        <Tabs
          activeKey={activeKey}
          onSelect={(k) => setActiveKey(k || "category")}
          id="categories-services-tabs"
          className="cs-tabs"
        >
          <Tab eventKey="category" title="Categorias">
            <div className="cs-tabBody">
              <Categories />
            </div>
          </Tab>

          <Tab eventKey="services" title="Serviços">
            <div className="cs-tabBody">
              {showServices && <Services />}
            </div>
          </Tab>
        </Tabs>
      </div>

      <FloatingVideoButton youtubeUrl={"https://www.youtube.com/embed/ESHPxn0KTiw"} />
    </div>
  );
}

export default CategoriesAnServices;
